import { Link } from 'react-router-dom';
import { Avatar } from '@/components/ui/Avatar';
import { Icon } from '@/components/ui/Icon';
import { useAuth } from '@/stores/auth';
import { useUs, useUsEnabled } from './api';

/**
 * The way into Us from the rest of Popin (Home, SPEC_V15 §2): a night field
 * with the two of you stuck on. Paired people go back to their space; others
 * learn what it is.
 */
export function UsEntry({ className }: { className?: string }) {
  const enabled = useUsEnabled();
  const me = useAuth((s) => s.me);
  const us = useUs();
  if (!enabled || us.isLoading || us.isError) return null;
  const space = us.data?.space;
  return (
    <Link
      to="/us"
      className={`relative flex min-h-[112px] items-center gap-4 overflow-hidden rounded-card bg-night p-5 pr-6 text-bone focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fg ${className ?? ''}`}
      data-testid="us-entry"
    >
      <span aria-hidden className="flex shrink-0 items-end">
        <span className="-rotate-[6deg]">
          <Avatar avatar={me?.avatar} size={56} sticker />
        </span>
        <span className="-ml-5 rotate-[8deg]">
          <Avatar avatar={space?.partner.avatar ?? { hue: 330, shape: 'blob', face: 'wink' }} size={50} sticker />
        </span>
      </span>
      <span className="min-w-0 flex-1">
        <span className="block font-display text-[30px] leading-[0.9]">{space ? 'Back to Us' : 'Just us'}</span>
        <span className="mt-1.5 block text-[15px] font-medium opacity-80">
          {space ? `Your space with ${space.partner.display_name}` : 'A private space for you and your person — watch together, call, chat'}
        </span>
      </span>
      <Icon name="chevron-right" size={20} />
    </Link>
  );
}
